module.exports = __webpack_public_path__ + "static/media/gift-card-banner.a9ccd294.png";